import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Input({
  type,
  className,
  ...props
}: ComponentProps<'input'>): JSX.Element {
  return (
    <input
      type={type}
      data-slot='input'
      className={cn(
        'file:text-foreground placeholder:text-[#bfbfbf] selection:bg-primary selection:text-primary-foreground dark:bg-input/30 flex h-11.5 w-full min-w-0 border bg-transparent',
        'text-base leading-[130%] shadow-none transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'px-4 py-3 rounded-md border-[#ececec] hover:border-[#cdcdcd] focus-visible:border-blueBonnet-500 aria-invalid:border-desire-500',
        className,
      )}
      {...props}
    />
  );
}
